export default require("@nait-aits/helper/polyfills");
